import React from 'react';
import CampaignCategoryInput from './CampaignCategoryInput';
import CampaignCategoryModal from './CampaignCategoryModal';
import LocationGroupModal from './LocationGroupModal';
import LocationGroupInput from './LocationGroupInput';
import TagInput from '../TagInput';
import LoadingSpinner from '../../../commonComponents/util/LoadingSpinner';
import { TagNames } from '../../../../lib/constants';

export default class CampaignSettings extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            modals: {
                campaignCategory: false,
                locationGroups: false
            },
            editLocationGroup: {
                groupName: '',
                members: []
            }
        };
    }

    editLocationGroup(groupId) {
        const index = this.props.settings.locationGroups.map(g => g.groupId).indexOf(groupId);
        const group = this.props.settings.locationGroups[index];
        if (group) {
            this.setState({ editLocationGroup: group }, () => this.toggleModal('locationGroups'));

        }
    }

    closeLocationGroupModal() {
        this.setState({ editLocationGroup: { groupName: '', members: [] } }, () => this.toggleModal('locationGroups'));
    }

    toggleModal(name) {
        this.setState({ modals: { ...this.state.modals, [name]: !this.state.modals[name] } });
    }

    render() {
        const { categories, campaignIndivCategories, locationGroups } = this.props.settings;
        return (
            <div>
                <div className="flex-justify settings-section">
                    <div className="column-half column-half-left">
                        <CampaignCategoryInput
                            campaignCategories={categories} delete={this.props.deleteSetting.bind(null, TagNames.CampaignCategories)}
                            showModal={this.toggleModal.bind(this, 'campaignCategory')} deleting={this.props.categories.delete} />
                    </div>
                    <div className="column-half column-half-right relative">
                        {this.props.loading && <div className="location-spinner"><LoadingSpinner height="32" /></div>}
                        <LocationGroupInput locationGroups={locationGroups} showModal={this.toggleModal.bind(this, 'locationGroups')}
                            delete={this.props.deleteSetting.bind(null, TagNames.LocationGroups)} onClick={this.editLocationGroup.bind(this)} deleting={this.props.locations.delete} />
                    </div>
                </div>
                <div style={{marginTop: "-16px"}}>
                 <TagInput title="Campaign Individual Categories"
                            values={campaignIndivCategories}
                            add={this.props.addSetting.bind(null, TagNames.CampaignIndivCategories)}
                            name='campaign individual category'
                            adding={this.props.individualCategories.add}
                            deleting={this.props.individualCategories.delete}
                            delete={this.props.deleteSetting.bind(null, TagNames.CampaignIndivCategories)} />
                  </div>

                <CampaignCategoryModal loading={this.props.categories.add.loading} success={this.props.categories.add.success} show={this.state.modals.campaignCategory} close={this.toggleModal.bind(this, 'campaignCategory')}
                    campaignTypes={this.props.categoryTypes} addCategory={this.props.addSetting.bind(null, TagNames.CampaignCategories)} />

                <LocationGroupModal loading={this.props.locations.add.loading || this.props.locations.update.loading} addingSuccess={this.props.locations.add.success} updatingSuccess={this.props.locations.update.success} show={this.state.modals.locationGroups}
                    close={this.closeLocationGroupModal.bind(this)} reloadCampaignSettings={this.props.reloadCampaignSettings}
                    addLocationGroup={this.props.addSetting.bind(null, TagNames.LocationGroups)} locationGroup={this.state.editLocationGroup}
                    updateLocationGroup={this.props.updateLocationGroup.bind(null, this.state.editLocationGroup.groupId)} />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/settingComponents/systemSettings/campaignSettings/CampaignSettings.jsx